(function () {
  function normaliseColourName(name) {
    if (window.WSM_NORMALISE_COLOUR) {
      return window.WSM_NORMALISE_COLOUR(name);
    }

    return String(name || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, 'and')
      .replace(/\+/g, 'and')
      .replace(/\//g, '-')
      .replace(/\s+/g, '-')
      .replace(/_/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getColour(name, fallback) {
    var key = normaliseColourName(name);

    if (window.WSM_GET_COLOUR) {
      return window.WSM_GET_COLOUR(name, fallback || '#cccccc');
    }

    if (window.WSM_COLOUR_MAP && window.WSM_COLOUR_MAP[key]) {
      return window.WSM_COLOUR_MAP[key];
    }

    return fallback || '#cccccc';
  }

  function cleanColourPart(part) {
    return String(part || '')
      .replace(/\btrim\b/gi, '')
      .replace(/\bcontrast\b/gi, '')
      .replace(/\bpanel\b/gi, '')
      .replace(/\bpanels\b/gi, '')
      .replace(/\bdetail\b/gi, '')
      .replace(/\bdetails\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function splitByTrueSeparators(raw) {
    var text = String(raw || '').trim();

    if (!text) return [];

    if (
      text.indexOf('/') === -1 &&
      text.indexOf('+') === -1 &&
      text.indexOf('&') === -1 &&
      text.toLowerCase().indexOf(' and ') === -1 &&
      text.toLowerCase().indexOf(' with ') === -1 &&
      text.indexOf(' - ') === -1
    ) {
      return [];
    }

    return text
      .replace(/\s*\/\s*/g, '|')
      .replace(/\s*\+\s*/g, '|')
      .replace(/\s*&\s*/g, '|')
      .replace(/\s+\band\b\s+/gi, '|')
      .replace(/\s+\bwith\b\s+/gi, '|')
      .replace(/\s+-\s+/g, '|')
      .split('|')
      .map(cleanColourPart)
      .filter(Boolean);
  }

  function makeGradient(colours) {
    if (colours.length === 2) {
      return (
        'linear-gradient(135deg, ' +
        colours[0] +
        ' 0%, ' +
        colours[0] +
        ' 50%, ' +
        colours[1] +
        ' 50%, ' +
        colours[1] +
        ' 100%)'
      );
    }

    if (colours.length === 3) {
      return (
        'linear-gradient(135deg, ' +
        colours[0] +
        ' 0%, ' +
        colours[0] +
        ' 33.33%, ' +
        colours[1] +
        ' 33.33%, ' +
        colours[1] +
        ' 66.66%, ' +
        colours[2] +
        ' 66.66%, ' +
        colours[2] +
        ' 100%)'
      );
    }

    return null;
  }

  function isPatternColour(name) {
    var key = String(name || '').toLowerCase().trim();

    return (
      key.indexOf('multi') !== -1 ||
      key.indexOf('assorted') !== -1 ||
      key.indexOf('mixed') !== -1 ||
      key.indexOf('camo') !== -1 ||
      key.indexOf('camouflage') !== -1 ||
      key.indexOf('print') !== -1 ||
      key.indexOf('pattern') !== -1 ||
      key.indexOf('stripe') !== -1 ||
      key.indexOf('check') !== -1 ||
      key.indexOf('checked') !== -1 ||
      key.indexOf('tartan') !== -1
    );
  }

  window.WSM_PAINT_SWATCHES = function (scope) {
    var root = scope || document;

    root.querySelectorAll('.js-wsm-swatch').forEach(function (swatch) {
      var colourName =
        swatch.getAttribute('data-colour-name') ||
        swatch.getAttribute('title') ||
        '';

      var colourParts = splitByTrueSeparators(colourName);
      var background = null;

      if (colourParts.length >= 2) {
        background = makeGradient(
          colourParts.slice(0, 3).map(function (part) {
            return getColour(part, '#cccccc');
          })
        );
      } else if (isPatternColour(colourName)) {
        background =
          'linear-gradient(135deg, #111827 0%, #111827 25%, #ffd900 25%, #ffd900 50%, #047857 50%, #047857 75%, #1d4ed8 75%, #1d4ed8 100%)';
      } else {
        background = getColour(colourName, '#cccccc');
      }

      if (background) {
        swatch.style.setProperty('--swatch--background', background);
        swatch.style.setProperty('background', background, 'important');
        swatch.style.setProperty('background-color', background, 'important');
      }
    });
  };

  function runPaints() {
    window.WSM_PAINT_SWATCHES();

    setTimeout(window.WSM_PAINT_SWATCHES, 100);
    setTimeout(window.WSM_PAINT_SWATCHES, 300);
    setTimeout(window.WSM_PAINT_SWATCHES, 700);
    setTimeout(window.WSM_PAINT_SWATCHES, 1200);
  }

  document.addEventListener('DOMContentLoaded', runPaints);
  window.addEventListener('load', runPaints);

  document.addEventListener('shopify:section:load', function (event) {
    window.WSM_PAINT_SWATCHES(event.target);
  });

  document.addEventListener('shopify:section:reorder', runPaints);
  document.addEventListener('shopify:block:select', runPaints);

  if (!window.WSM_SWATCH_OBSERVER_ACTIVE) {
    window.WSM_SWATCH_OBSERVER_ACTIVE = true;

    new MutationObserver(function () {
      window.WSM_PAINT_SWATCHES();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();